import React, { useEffect, useRef, useState } from 'react';
import { googlePlayStoreLink } from '../../../Constants/branchUrls';
import {
  getDeviceType,
  getScreenName,
  isAndroidAppUser,
} from '../../../Utils/helper';
import { isIOSAppUser } from '../../../Utils/IosUtils';
// import DesktopInstallNotif from "../../QnaPage/DesktopInstallNotif/DesktopInstallNotif";
import InstallNudge from '../../QnaPage/InstallNudge/InstallNudge';
import { InstallNudgeElseDiv } from '../../QnaPage/InstallNudge/styled';
import { fireEvent } from '../../../Utils/fireEvent';

function AppInstallNudge(props) {
  const [showInstallStrip, setShowInstallStrip] = useState(true);
  // const [appIsPreasent, setAppIsPresent] = useState();
  // const [branchUrl, setBranchUrl] = useState();
  const installLink = googlePlayStoreLink;
  const deviceType = useRef();
  const [AppUser, setAppUser] = useState(false);

  useEffect(() => {
    if (isAndroidAppUser() || isIOSAppUser()) {
      // getBranchParameters();
      deviceType.current = getDeviceType();
      setAppUser(true);
    }
  }, []);
  // const getBranchParameters = async () => {
  //     const { branchUrl, appInstalledOrNot } = await appCheck(
  //         "babynames",
  //         "",
  //     );
  //     setBranchUrl(branchUrl);
  //     setAppIsPresent(appInstalledOrNot);
  // };

  const closeInstallStrip = () => {
    fireEvent({
      category: 'discard_strip',
      screen_name: getScreenName(),
      page_url: typeof window != 'undefined' ? window.location.href : 'NA',
      parent: 'Install App Nudge Strip Mobile',
    });
    setShowInstallStrip(false);
  };

  return (
    <>
      {!AppUser && (
        <>
          {showInstallStrip ? (
            <InstallNudge
              installLink={installLink}
              closeInstallStrip={closeInstallStrip}
              appIsPreasent={false}
            />
          ) : (
            <InstallNudgeElseDiv></InstallNudgeElseDiv>
          )}
          {/* {deviceType.current == "desktop" ? (
                        <DesktopInstallNotif
                            installLink={installLink}
                            contentType={"babynames"}
                            contentData={["default"]}
                            showDesktopNotifPopup={false}
                            showInstallNotifCard={true}
                            contentId={""}
                        />
                    ) : null} */}
        </>
      )}
    </>
  );
}

export default AppInstallNudge;
